import axios from "axios";
import { cusAxios, PREFIX } from "./main";
import { checkUrlBotTg, ENUM_MADE_ON } from "../store/enums";
import { getLang } from "../utils/utils";

const info = async (data) => {
  const madeOn = checkUrlBotTg() ? ENUM_MADE_ON.tgBot : ENUM_MADE_ON.site;

  let response = await axios({
    method: "POST",
    url: `${PREFIX}/api/gamers/casino_info`,
    data: { madeOn, ...data }
  });
  return response;
};

const getGameUrl = async (data) => {
  const madeOn = checkUrlBotTg() ? ENUM_MADE_ON.tgBot : ENUM_MADE_ON.site;
  const lang = getLang();

  let response = await axios({
    method: "POST",
    url: `${PREFIX}/api/gamers/start_game`,
    data: { ...data, madeOn, lang }
  });
  return response;
};

const getBonusGameUrl = async (data) => {
  const madeOn = checkUrlBotTg() ? ENUM_MADE_ON.tgBot : ENUM_MADE_ON.site;
  const lang = getLang();

  let response = await axios({
    method: "POST",
    url: `${PREFIX}/api/gamers/start_bonus`,
    data: { ...data, madeOn, lang }
  });
  return response;
};

const getGameStat = async () => {
  const madeOn = checkUrlBotTg() ? ENUM_MADE_ON.tgBot : ENUM_MADE_ON.site;
  const lang = getLang();

  let response = await axios({
    method: "POST",
    url: `${PREFIX}/api/gamers/game_stat`,
    data: { madeOn, lang }
  });
  return response;
};

const getBonuses = async ({ start_r, currency }) => {
  const madeOn = checkUrlBotTg() ? ENUM_MADE_ON.tgBot : ENUM_MADE_ON.site;
  const lang = getLang();

  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/get_bonuses`,
    data: { madeOn, lang, start_r, currency }
  });
  return response;
};

const setActive = async (data) => {
  const madeOn = checkUrlBotTg() ? ENUM_MADE_ON.tgBot : ENUM_MADE_ON.site;
  const lang = getLang();

  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/bonus_set_activation`,
    data: { madeOn, lang, ...data }
  });
  return response;
};

const getJackpots = async ({ start_r, currency }) => {
  const madeOn = checkUrlBotTg() ? ENUM_MADE_ON.tgBot : ENUM_MADE_ON.site;
  const lang = getLang();

  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/get_jackpots`,
    data: { madeOn, lang, start_r, currency }
  });
  return response;
};

const getCampaignId = async ({ start_r, campaignId }) => {
  const madeOn = checkUrlBotTg() ? ENUM_MADE_ON.tgBot : ENUM_MADE_ON.site;
  const lang = getLang();

  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/campaign_info`,
    data: { madeOn, lang, start_r, campaignId }
  });
  return response;
};

const checkDomain = async ({ start_r, domain }) => {
  const madeOn = checkUrlBotTg() ? ENUM_MADE_ON.tgBot : ENUM_MADE_ON.site;
  const lang = getLang();

  let response = await axios({
    method: "POST",
    url: `${PREFIX}/api/gamers/check_domain`,
    data: { madeOn, lang, start_r, domain }
  });
  return response;
};

const captchaUsing = async ({ start_r }) => {
  const madeOn = checkUrlBotTg() ? ENUM_MADE_ON.tgBot : ENUM_MADE_ON.site;
  const lang = getLang();

  let response = await axios({
    method: "POST",
    url: `${PREFIX}/api/gamers/captcha_using`,
    data: { madeOn, lang, start_r }
  });
  return response;
};

// const getAgreement = async ({ lang }) => {
//   const madeOn = checkUrlBotTg() ? ENUM_MADE_ON.tgBot : ENUM_MADE_ON.site;

//   const params = new URLSearchParams({
//     madeOn: madeOn,
//     lang: lang
//   });

//   let response = await cusAxios({
//     method: "POST",
//     url: `${PREFIX}/api/gamers/agreement`,
//     data: params,
//     headers: {
//       "Content-Type": "application/x-www-form-urlencoded"
//     }
//   });
//   return response;
// };

const getAgreement = async ({ lang }) => {
  const madeOn = checkUrlBotTg() ? ENUM_MADE_ON.tgBot : ENUM_MADE_ON.site;

  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/agreement`,
    data: { madeOn, lang }
  });
  return response;
};

const getProviderList = async () => {
  const madeOn = checkUrlBotTg() ? ENUM_MADE_ON.tgBot : ENUM_MADE_ON.site;
  const lang = getLang();

  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/provider_list`,
    data: { madeOn, lang }
  });
  return response;
};

const getProviderGamesList = async ({ providerId, maxGames }) => {
  const madeOn = checkUrlBotTg() ? ENUM_MADE_ON.tgBot : ENUM_MADE_ON.site;
  const lang = getLang();

  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/provider_game_list`,
    data: { madeOn, lang, providerId, maxGames }
  });
  return response;
};

const getCategoryGamesList = async ({ categoryId, maxGames }) => {
  const madeOn = checkUrlBotTg() ? ENUM_MADE_ON.tgBot : ENUM_MADE_ON.site;
  const lang = getLang();

  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/category_game_list`,
    data: { madeOn, lang, categoryId, maxGames }
  });
  return response;
};

const getGamesByString = async ({ sample }) => {
  const madeOn = checkUrlBotTg() ? ENUM_MADE_ON.tgBot : ENUM_MADE_ON.site;
  const lang = getLang();

  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/search_game`,
    data: { madeOn, lang, sample }
  });
  return response;
};

const getGamesById = async ({ gameId }) => {
  const madeOn = checkUrlBotTg() ? ENUM_MADE_ON.tgBot : ENUM_MADE_ON.site;
  const lang = getLang();

  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/game_info`,
    data: { madeOn, lang, gameId }
  });
  return response;
};

const getHitGames = async ({ maxGames } = {}) => {
  const madeOn = checkUrlBotTg() ? ENUM_MADE_ON.tgBot : ENUM_MADE_ON.site;
  const lang = getLang();

  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/hit_game_list`,
    data: { madeOn, lang, maxGames }
  });
  return response;
};

const getFavoritesGames = async ({ maxGames }) => {
  const madeOn = checkUrlBotTg() ? ENUM_MADE_ON.tgBot : ENUM_MADE_ON.site;
  const lang = getLang();

  let response = await cusAxios({
    method: "POST",
    url: `${PREFIX}/api/gamers/favorites_game_list`,
    data: { madeOn, lang, maxGames }
  });
  return response;
};

export const API_CASINO = {
  info,
  getGameUrl,
  getBonusGameUrl,
  getGameStat,
  getJackpots,
  getCampaignId,
  captchaUsing,
  checkEmailDomain: checkDomain,
  agreement: getAgreement,
  list: {
    providers: getProviderList,
    providerGames: getProviderGamesList,
    categoryGames: getCategoryGamesList,
    search: getGamesByString,
    games: getGamesById,
    hit: getHitGames,
    favorites: getFavoritesGames
  },
  bonus: {
    get: getBonuses,
    setActive
  }
};
